import './sentry';
import * as Sentry from '@sentry/react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import amplifyConfig from './aws-exports';
import ThemeWrapper from './theme/ThemeWrapper';
import { store } from './redux/store';
import RoutesPage from './routes';

Amplify.configure(amplifyConfig);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong</div>}>
      <BrowserRouter>
        <Provider store={store}>
          <ThemeWrapper>
            <RoutesPage />
          </ThemeWrapper>
        </Provider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
